// import React, { useEffect, useState } from "react";
// import { useQuery } from "react-query";
// import { Select } from "antd";
// import useAxiosInstance from "../../../../lib/useAxiosInstance";

// const { Option } = Select; // (optional, if you ever want to use <Select.Option>)

// const uniq = (arr) => [...new Set(arr.filter(Boolean))];

// const Filters = ({ surveyId, onFiltersChange }) => {
//   const axiosInstance = useAxiosInstance();

//   const [selectedBlock, setSelectedBlock] = useState("");
//   const [selectedVillage, setSelectedVillage] = useState("");
//   const [selectedBooth, setSelectedBooth] = useState("");

//   // Notify parent when selection changes
//   useEffect(() => {
//     onFiltersChange?.({
//       block: selectedBlock,
//       village: selectedVillage,
//       booth: selectedBooth,
//     });
//   }, [selectedBlock, selectedVillage, selectedBooth]);

//   // -------- SINGLE API CALL BASED ON FILTERS --------
//   const { data: dataset = [], isLoading } = useQuery(
//     ["respondents", surveyId, selectedBlock, selectedVillage],
//     async () => {
//       const res = await axiosInstance.get(
//         `/api/surveyAnalytics/allRespondants/${surveyId}`,
//         {
//           params: {
//             block: selectedBlock || undefined,
//             village: selectedVillage || undefined,
//           },
//         }
//       );
//       return res?.data?.data || [];
//     },
//     {
//       enabled: !!surveyId,
//       refetchOnWindowFocus: false,
//       retry: 1,
//     }
//   );

//   // -------- DERIVED OPTIONS --------
//   const blockOptions = uniq(dataset.map((d) => d.block));
//   const villageOptions = selectedBlock
//     ? uniq(dataset.map((d) => d.village))
//     : [];

//   const boothOptions =
//     selectedBlock && selectedVillage
//       ? uniq(dataset.map((d) => d.booth))
//       : [];

//   // -------- HANDLERS (antd Select gives value directly) --------
//   const handleBlockChange = (value) => {
//     const newValue = value || "";
//     setSelectedBlock(newValue);
//     setSelectedVillage("");
//     setSelectedBooth("");
//   };

//   const handleVillageChange = (value) => {
//     const newValue = value || "";
//     setSelectedVillage(newValue);
//     setSelectedBooth("");
//   };

//   const handleBoothChange = (value) => {
//     const newValue = value || "";
//     setSelectedBooth(newValue);
//   };

//   return (
//     <div className="inline-flex flex-col gap-3 items-center bg-white/80 backdrop-blur-md border border-slate-200 rounded-2xl px-4 py-3 shadow-md">
//       {/* BLOCK */}
//       <div className="flex flex-col text-sm">
//         <label className="mb-1 font-medium text-slate-700">Block</label>
//         <Select
//           name="block"
//           placeholder="Select Block"
//           style={{ width: 220 }}
//           value={selectedBlock || undefined}
//           onChange={handleBlockChange}
//           allowClear
//           showSearch
//           disabled={isLoading}
//           getPopupContainer={(trigger) => trigger.parentNode}
//           optionFilterProp="label"
//           options={blockOptions.map((b) => ({
//             value: b,
//             label: b,
//           }))}
//         />
//       </div>

//       {/* VILLAGE */}
//       <div className="flex flex-col text-sm">
//         <label className="mb-1 font-medium text-slate-700">Village</label>
//         <Select
//           name="village"
//           placeholder={selectedBlock ? "Select Village" : "Select Block first"}
//           style={{ width: 220 }}
//           value={selectedVillage || undefined}
//           onChange={handleVillageChange}
//           allowClear
//           showSearch
//           disabled={!selectedBlock || isLoading}
//           getPopupContainer={(trigger) => trigger.parentNode}
//           optionFilterProp="label"
//           options={villageOptions.map((v) => ({
//             value: v,
//             label: v,
//           }))}
//         />
//       </div>

//       {/* BOOTH */}
//       <div className="flex flex-col text-sm">
//         <label className="mb-1 font-medium text-slate-700">Booth</label>
//         <Select
//           name="booth"
//           placeholder={
//             selectedVillage ? "Select Booth" : "Select Village first"
//           }
//           style={{ width: 220 }}
//           value={selectedBooth || undefined}
//           onChange={handleBoothChange}
//           allowClear
//           showSearch
//           disabled={!selectedVillage || isLoading}
//           getPopupContainer={(trigger) => trigger.parentNode}
//           optionFilterProp="label"
//           options={boothOptions.map((b) => ({
//             value: b,
//             label: b,
//           }))}
//         />
//       </div>
//     </div>
//   );
// };

// export default Filters;


import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import useAxiosInstance from "../../../../lib/useAxiosInstance";

const uniq = (arr) => [...new Set(arr.filter(Boolean))];

const Filters = ({ surveyId, surveyType, onFiltersChange,selectedLocationFromMap }) => {
  const axiosInstance = useAxiosInstance();

  const [selectedConstituency, setSelectedConstituency] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");
  const [selectedBooth, setSelectedBooth] = useState("");

  useEffect(() => {
    if (selectedLocationFromMap === null) {
      setSelectedConstituency("");
      setSelectedVillage("");
      setSelectedBooth("");
    }

    if (surveyType === "parliamentary" || surveyType === "state") {
      setSelectedConstituency((prev) =>
        prev !== selectedLocationFromMap ? selectedLocationFromMap : prev
      );
      setSelectedVillage("");
      setSelectedBooth("");
    } else {
      setSelectedVillage((prev) =>
        prev !== selectedLocationFromMap ? selectedLocationFromMap : prev
      );
      setSelectedBooth("");
    }
  }, [selectedLocationFromMap, surveyType]);

  // -------- Notify Parent --------
  useEffect(() => {
    onFiltersChange?.({
      constituency:
        (surveyType === "parliamentary" || surveyType === "state") ? selectedConstituency : undefined,
      village: selectedVillage,
      booth: selectedBooth
    });
  }, [selectedConstituency, selectedVillage, selectedBooth, surveyType]);

  // -------- API CALL --------
  const { data: dataset = [], isLoading } = useQuery(
    [
      "respondents",
      surveyId,
      surveyType,
      selectedConstituency,
      selectedVillage
    ],
    async () => {
      const res = await axiosInstance.get(
        `/api/surveyAnalytics/allRespondants/${surveyId}`,
        {
          params: {
            constituency:
              surveyType === "parliamentary"
                ? selectedConstituency || undefined
                : undefined,
            village: selectedVillage || undefined
          }
        }
      );
      return res?.data?.data || [];
    },
    {
      enabled: !!surveyId,
      refetchOnWindowFocus: false,
      retry: 1
    }
  );
  // -------- OPTIONS --------
  const constituencyOptions =
    (surveyType === "parliamentary" || surveyType === "state")
      ? uniq(dataset.map((d) => d.constituency || d.pcName))
      : [];
  const villageOptions =
   ( surveyType === "parliamentary" || surveyType === "state")
      ? selectedConstituency
        ? uniq(dataset.map((d) => d.village))
        : []
      : uniq(dataset.map((d) => d.village));

  const boothOptions = selectedVillage
  ? uniq(dataset.map((d) => d.booth))
  : [];

  // -------- HANDLERS --------
  const handleConstituencyChange = (value) => {
    setSelectedConstituency(value || "");
    setSelectedVillage("");
    setSelectedBooth("");
  };

  const handleVillageChange = (value) => {
    setSelectedVillage(value || "");
    setSelectedBooth("");
  };

  const handleBoothChange = (value) => {
    setSelectedBooth(value || "");
  };

  return (
    <div className="inline-flex flex-col gap-3 items-center bg-white/80 backdrop-blur-md border border-slate-200 rounded-2xl px-4 py-3 shadow-md">

      {/* CONSTITUENCY (PARLIAMENTARY ONLY) */}
      {(surveyType === "parliamentary" || surveyType === "state") && (
        <div className="flex flex-col text-sm">
          <label className="mb-1 font-medium text-slate-700">
            Constituency
          </label>
          <Select
            key={constituencyOptions.length}
            name="constituency"
            placeholder="Select Constituency"
            style={{ width: 220 }}
            value={selectedConstituency || undefined}
            onChange={handleConstituencyChange}
            getPopupContainer={(trigger) => trigger.parentNode}
            allowClear
            showSearch
            optionFilterProp="label"
            options={constituencyOptions.map((c) => ({
              value: c,
              label: c
            }))}
          />
        </div>
      )}

      {/* VILLAGE */}
      <div className="flex flex-col text-sm">
        <label className="mb-1 font-medium text-slate-700">Village</label>
        <Select
          placeholder={
            (surveyType === "parliamentary" || surveyType === "state") && !selectedConstituency
              ? "Select Constituency first"
              : "Select Village"
          }
          style={{ width: 220 }}
          value={selectedVillage || undefined}
          onChange={handleVillageChange}
          allowClear
          showSearch
          disabled={
            isLoading ||
            ((surveyType === "parliamentary" || surveyType === "state") && !selectedConstituency)
          }
          getPopupContainer={(trigger) => trigger.parentNode}
          optionFilterProp="label"
          options={villageOptions.map((v) => ({
            value: v,
            label: v
          }))}
        />
      </div>

      {/* BOOTH */}
      <div className="flex flex-col text-sm">
         <label className="mb-1 font-medium text-slate-700">Booth</label>
         <Select
          name="booth"
          placeholder={
            selectedVillage ? "Select Booth" : "Select Village first"
          }
          style={{ width: 220 }}
          value={selectedBooth || undefined}
          onChange={handleBoothChange}
          allowClear
          showSearch
          disabled={!selectedVillage || isLoading}
          getPopupContainer={(trigger) => trigger.parentNode}
          optionFilterProp="label"
          options={boothOptions.map((b) => ({
            value: b,
            label: b,
          }))}
        />
      </div>
    </div>
  );
};

export default Filters;
